export const lineHeights = {
  normal: { value: "normal" },
  none: { value: "1" },
  shorter: { value: "1.25" },
  short: { value: "1.375" },
  base: { value: "1.5" },
  tall: { value: "1.625" },
  taller: { value: "2" },
};
